const bonusesKey = 'shop-bonuses'
const bonusesUsedKey = 'shop-bonuses-used'
let bonusesUsedOnPage = 0

function getLSItem(key) {
    try {
        return +localStorage.getItem(key)
    } catch (e) {
        return 0
    }
}

function setLSItem(key, value) {
    try {
        localStorage.setItem(key, value)
    } catch (e) {
    }
}

function getBonusesUsed() {
    return getLSItem(bonusesUsedKey)
}

function getBonuses() {
    return getLSItem(bonusesKey)
}

function setBonusesUsed(value) {
    return setLSItem(bonusesUsedKey, value)
}

function setBonuses(value) {
    return setLSItem(bonusesKey, value)
}

function setLocalBonuses() {
    const shopBonuses = document.querySelector('.js-bonus-value')
    if (shopBonuses) {
        const shopBonusesValue = shopBonuses.dataset.value
        if (shopBonusesValue) {
            setBonuses(shopBonusesValue)
        }
    }
}

function showBonusesInItemList() {
    const itemsInBonusSystem = document.querySelectorAll('.js-product-item[data-bonus-system="1"]')
    const bonusesLeft = Math.max(0, getBonuses() - getBonusesUsed())

    if (itemsInBonusSystem && bonusesLeft > 0) {
        itemsInBonusSystem.forEach((el) => {
            const priceElement = el.querySelector('.js-product-price')
            const priceBase = priceElement.querySelector('div')
            const priceBaseValue = +(priceBase.innerText.substring(0, priceBase.innerText.length - 4))
            priceBase.classList.add('price-discount', '_right')
            const newPriceValue = Math.max(1, priceBaseValue - bonusesLeft) // цена всегда минимум 1 рубль
            const newPrice = document.createElement('div')
            newPrice.classList.add('_discounted')
            newPrice.innerHTML = `${newPriceValue} руб`
            priceElement.appendChild(newPrice)
        })
    }
}

function changeItemCount(buttonSelector, operator) {
    const button = document.querySelector(buttonSelector)
    if (button) {
        button.addEventListener('click', () => {
            const priceElement = document.querySelector('.js-product-item-detail[data-bonus-system="1"] .js-product-price')
            const priceBase = priceElement.querySelector('div')
            const priceBaseValue = +(priceBase.innerText.substring(0, priceBase.innerText.length - 4))
            bonusesUsedOnPage = operator(bonusesUsedOnPage, priceBaseValue) // +/-
            showBonusesInItemDetail()
        })
    }
}

function addItem() {
    changeItemCount('.js-count-plus', (a, b) => a + b)
}

function removeItem() {
    changeItemCount('.js-count-minus', (a, b) => a - b)
}

function itemToCard() {
    const button = document.querySelector('.js-make-order')
    if (button) {
        button.addEventListener('click', () => {
            setBonusesUsed(getBonusesUsed() + bonusesUsedOnPage)
            bonusesUsedOnPage = 0
        })
    }

}

function showBonusesInItemDetail() {
    const itemsInBonusSystem = document.querySelectorAll('.js-product-item-detail[data-bonus-system="1"]')
    const bonusesLeft = Math.max(0, getBonuses() - getBonusesUsed() - bonusesUsedOnPage)
    if (itemsInBonusSystem && bonusesLeft > 0) {
        itemsInBonusSystem.forEach((el) => {
            const priceElement = el.querySelector('.js-product-price')
            const priceBase = priceElement.querySelector('div')
            const priceBaseValue = +(priceBase.innerText.substring(0, priceBase.innerText.length - 4))
            console.log(priceBase.classList)
            priceBase.classList.add('price-discount', '_right')
            const newPriceValue = Math.max(1, priceBaseValue - bonusesLeft) // цена всегда минимум 1 рубль
            const newPrice = document.createElement('div')
            newPrice.classList.add('_discounted')
            newPrice.innerHTML = `${newPriceValue} руб`
            priceElement.appendChild(newPrice)
        })
    }
    if (bonusesLeft <= 0 && bonusesUsedOnPage > 0) { // если больше бонусов нет (при добавлении товара)
        const priceBase = document.querySelector('.price-discount._right')
        priceBase.classList.remove('price-discount', '_right')
        document.querySelector('._discounted').remove()
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setLocalBonuses() // на странице, где есть баллы, устанавливаем их в localstorage
    showBonusesInItemList() // показываем цену с бонусами на списке товаров
    showBonusesInItemDetail() // показываем цену в детальной странице

    addItem() // обрабатываем добавление вещи в детальной странице
    removeItem() // обрабатываем удаление вещи в детальной странице
})



//////////////////
// WEBPACK FOOTER
// ./src/js/bonuses.js
// module id = 7
// module chunks = 0 1 2